import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoRfidBadgeOrderListEmspUserFirstNameHeaderProps
  extends HeaderContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['emspUser']['firstName']
  > {}

export const EmspBoRfidBadgeOrderListEmspUserFirstNameHeader =
  (): // props: EmspBoRfidBadgeOrderListEmspUserFirstNameHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-emsp-user.first-name');
  };
